import { Box, Flex, Label, RadioButton, Text } from '@modusign/design-system';

import getFormattedParticipantInfo from '@app/features/inPerson/lib/getFormattedParticiapntInfo';

interface ModalParticipantSelectBoxProps {
  participants: Array<{ name?: string | null; contact?: string; id: string }>;
  onClick: (participantId: string) => void;
  selectedParticipantId: string | null;
}

export default function ModalParticipantSelectBox({
  participants,
  selectedParticipantId,
  onClick,
}: ModalParticipantSelectBoxProps) {
  if (participants.length === 0) return null;

  const Contact =
    participants.length > 1 ? (
      <Flex flexDirection="column" gap={4} my={6}>
        {participants.map((p) => {
          const formId = `modal-participant-select-radio-${p.id}`;
          return (
            <Flex alignItems="flex-start" key={formId}>
              <Box mt={1}>
                <RadioButton
                  checked={selectedParticipantId === p.id}
                  id={formId}
                  onClick={() => onClick(p.id)}
                />
              </Box>
              <Label htmlFor={formId} mb={0} ml={3}>
                <Text
                  sx={{
                    cursor: 'pointer',
                    fontWeight: 'medium',
                  }}
                >
                  {p.name && p.contact && getFormattedParticipantInfo(p.name, p.contact)}
                </Text>
              </Label>
            </Flex>
          );
        })}
      </Flex>
    ) : (
      <Flex justifyContent="center" py={6} width="100%">
        <Text fontSize="md" fontWeight="medium" textAlign="center">
          {participants[0].name &&
            participants[0].contact &&
            getFormattedParticipantInfo(participants[0].name, participants[0].contact)}
        </Text>
      </Flex>
    );

  return (
    <Box
      borderColor="boxBorderNeutralBase"
      borderRadius="2px"
      borderStyle="solid"
      borderWidth="1px"
      maxHeight="200px"
      my={6}
      overflow="auto"
      px={6}
    >
      {Contact}
    </Box>
  );
}
